<template>
    <div class="step-template">
        <div class="text-wrapper">
            <div class="left-wrapper">
                <h1>Blutzucker-werte</h1>
                <p class="h2">Die Ergebnisse der Reduktion von Gewicht und Bauchumfang können zu verbesserten Blutzuckerwerten führen...</p>
            </div>
            <div class="right-wrapper">
                <h2>Wie kann so ein Ergebnis aussehen?</h2>
                <p class="text">...und einer Senkung des Langzeitblutzuckerspiegels von in der Regel 0,8 %.</p>
            </div>
        </div>

        <MobileTemplate @app-step-from-mobile-template="actualStep" weiterBtn :appStep="appStep" />
    </div>
</template>

<script>
export default {
    data(){
        return {
            appStep: 22
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}
</script>

